import { create } from 'zustand';
import type { ProductionCycle } from '../types';
import { db } from '../db/database';

interface CycleStore {
  cycles: ProductionCycle[];
  loadCycles: () => Promise<void>;
  saveCycle: (cycle: ProductionCycle) => Promise<void>;
  deleteCycle: (id: string) => Promise<void>;
  getCycle: (id: string) => ProductionCycle | undefined;
}

export const useCycleStore = create<CycleStore>((set, get) => ({
  cycles: [],

  loadCycles: async () => {
    try {
      const cycles = await db.cycles.toArray();
      // Sort by timestamp descending (newest first)
      cycles.sort((a, b) => b.timestamp - a.timestamp);
      set({ cycles });
    } catch (error) {
      console.error('Failed to load cycles from IndexedDB:', error);
      set({ cycles: [] });
    }
  },

  saveCycle: async (cycle: ProductionCycle) => {
    try {
      await db.cycles.put(cycle);
      // Reload cycles to update the list
      await get().loadCycles();
    } catch (error) {
      console.error('Failed to save cycle to IndexedDB:', error);
      throw error;
    }
  },

  deleteCycle: async (id: string) => {
    try {
      await db.cycles.delete(id);
      // Update local state
      set((state) => ({
        cycles: state.cycles.filter((cycle) => cycle.id !== id),
      }));
    } catch (error) {
      console.error('Failed to delete cycle from IndexedDB:', error);
      throw error;
    }
  },

  getCycle: (id: string) => {
    const { cycles } = get();
    return cycles.find((cycle) => cycle.id === id);
  },
}));
